<template lang="pug">
  game-preview-settings
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
      span(slot="value") {{ $i18n.t('common.common_gameName_assembleTheNumber') }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
      span(slot="value")
        | {{ digitCapacityMode }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
      span(slot="value", v-if="parameters.infinityAmountOfExamples" ) {{$i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples')}}
      span(slot="value", v-else) {{ parameters.numOfExamples }}
    game-preview-setting(v-if="parameters.timeLimit")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
      span(slot="value") {{ timeLimit }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_coloredNumbers') }}
      span(slot="value") {{ getTitleForSetting(settings.coloredNumbers) }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        data() {
            return {
                digitalCapacityModes: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        value: 4,
                    },
                ],
            };
        },
        props: {
            parameters: Object,
            exerciseId: [Number, String],
            type: String,
        },
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        methods: {
            getTitleForSetting(setting) {
                return setting
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
            },
        },
        computed: {
            digitCapacityMode() {
                return this.digitalCapacityModes.find(mode => mode.value === +this.parameters.digitCapacity).label;
            },
            timeLimit() {
                return (
                    this.parameters.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
                );
            },
        },
    };
</script>
